import { __awaiter } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { FeedbackMessage, FeedbackMessageVariant, Heading, HeadingType } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { EticketHeader } from '../components/eticket/eticket-header/EticketHeader';
import { EticketBody } from '../components/eticket/eticket-body/EticketBody';
import { EticketFooter } from '../components/eticket/eticket-footer/EticketFooter';
import { useAemConfig } from '@as-react/common-components';
import EticketAPI from '../api/EticketAPI';
import { getQuerystringByName } from '../util/URLParamUtil';
import { CUSTOMER_UUID, RATING, SALE_ID } from '../constants/StorageKeysConstants';
import { analyticsActions } from '../redux/analytics/actions/AnalyticsActions.creators';
import { Box, Stack } from '@yonderland/andes-react';
export const ETICKET_CONSTANTS = {
    RATING_TYPE: {
        SALE: 11,
        DEPARTMENT: 12,
        REGISTER: 13,
    },
    RATING: {
        GOOD: 5,
        OK: 3,
        BAD: 1,
    },
};
const EticketContainer = ({ departments, feedback }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const { defaultRequestParams, servicesEndpoint, mainWebShop } = useAemConfig();
    const dispatch = useDispatch();
    const [queryCustomerUuid, setQueryCustomerUuid] = useState('');
    const [querySaleId, setQuerySaleId] = useState('');
    const [ticketInfoError, setTicketInfoError] = useState(false);
    const [goodRating, setGoodRating] = useState(null);
    const [feedbackFormSuccess, setFeedbackFormSuccess] = useState(false);
    const [feedbackFormError, setFeedbackFormError] = useState(false);
    const [eTicketInformation, setEticketInformation] = useState();
    useEffect(() => {
        setQueryCustomerUuid(getQuerystringByName(window.location.search, CUSTOMER_UUID));
        setQuerySaleId(getQuerystringByName(window.location.search, SALE_ID));
    }, []);
    useEffect(() => {
        const getCustomerInfo = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const info = yield EticketAPI.getTicketInformation(defaultRequestParams, servicesEndpoint, queryCustomerUuid, querySaleId);
                setEticketInformation(info);
                if (!info.alreadyVotedOnSale) {
                    EticketAPI.voting(defaultRequestParams, servicesEndpoint, queryCustomerUuid, querySaleId, ETICKET_CONSTANTS.RATING_TYPE.SALE, Number(getQuerystringByName(window.location.search, RATING)));
                }
                else {
                    setGoodRating(info.saleRating);
                }
            }
            catch (_a) {
                setTicketInfoError(true);
            }
        });
        if (queryCustomerUuid && querySaleId) {
            getCustomerInfo();
        }
    }, [queryCustomerUuid, querySaleId]);
    const sendCustomFeedback = (feedbackText) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield EticketAPI.sendFeedback(defaultRequestParams, servicesEndpoint, queryCustomerUuid, querySaleId, feedbackText);
            dispatch(analyticsActions.eTicketSendFeedback());
            setFeedbackFormSuccess(true);
        }
        catch (_a) {
            setFeedbackFormError(true);
        }
    });
    const rateProduct = (rating, departmentId) => EticketAPI.voting(defaultRequestParams, servicesEndpoint, queryCustomerUuid, querySaleId, departmentId ? ETICKET_CONSTANTS.RATING_TYPE.DEPARTMENT : ETICKET_CONSTANTS.RATING_TYPE.REGISTER, rating, departmentId);
    if (ticketInfoError) {
        return _jsx(FeedbackMessage, { variant: FeedbackMessageVariant.NEGATIVE, text: t('eticket.error') });
    }
    if (!eTicketInformation) {
        return null;
    }
    return (_jsxs(Box, { paddingBlockEnd: "12", children: [_jsxs(Stack, { direction: "col", gap: { base: '4', lg: '6' }, children: [_jsx(Heading, { type: HeadingType.TITLE, children: t('eticket.opinion') }), feedback && (_jsx(EticketHeader, { goodRating: goodRating, sendCustomFeedback: sendCustomFeedback, feedbackFormSuccess: feedbackFormSuccess, feedbackFormError: feedbackFormError }))] }), _jsxs(Stack, { direction: "col", gap: "8", children: [departments && _jsx(EticketBody, { rateProduct: rateProduct, eTicketInformation: eTicketInformation }), _jsx(EticketFooter, { mainWebShop: mainWebShop })] })] }));
};
export default EticketContainer;
